// How code and diffs are drawn on this device (Settings → Appearance → Code): the colours
// of the words, bracket pairs by depth, rainbow indent guides, ligatures in the code font.
// Per device like the appearance, and on by default.
import { create } from 'zustand'

const KEY = 'code-look'

export interface CodeLook {
  /** colour the words; off draws plain text in the code font */
  highlight: boolean
  brackets: boolean
  guides: boolean
  ligatures: boolean
}

const DEFAULT: CodeLook = { highlight: true, brackets: true, guides: true, ligatures: true }

const read = (): CodeLook => {
  try {
    const v = JSON.parse(localStorage.getItem(KEY) ?? '{}') as Partial<CodeLook>
    const pick = (k: keyof CodeLook) => (typeof v[k] === 'boolean' ? v[k] : DEFAULT[k])
    return { highlight: pick('highlight'), brackets: pick('brackets'), guides: pick('guides'), ligatures: pick('ligatures') }
  } catch {
    return DEFAULT
  }
}

export const useCodeLook = create<CodeLook & { set: (patch: Partial<CodeLook>) => void }>((set, get) => ({
  ...read(),
  set: (patch) => {
    const { highlight, brackets, guides, ligatures } = { ...get(), ...patch }
    try {
      localStorage.setItem(KEY, JSON.stringify({ highlight, brackets, guides, ligatures }))
    } catch {
      /* private mode: this session only */
    }
    set({ highlight, brackets, guides, ligatures })
  },
}))
